import { api } from "./api";
import {
  GET_BATCHES_BY_STUDENT,
  GET_BATCHES_BY_COACHING,
  GET_BATCHES_FEESTRUCTURE,
} from "../apiEndPoints";

export const batchApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getStudentBatches: builder.query({
      query: (student_id) => {
        return {
          url: `${GET_BATCHES_BY_STUDENT}?student_id=${student_id}`,
          method: "GET",
        };
      },
    }),
    getCoachingBatches: builder.query({
      query: (coaching_id) => {
        return {
          url: `${GET_BATCHES_BY_COACHING}?coaching_id=${coaching_id}`,
          method: "GET",
        };
      },
    }),
    getBatchFeeStructure: builder.query({
      query: (batch_id) => {
        return {
          url: `${GET_BATCHES_FEESTRUCTURE}?batch_id=${batch_id}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetStudentBatchesQuery,
  useGetBatchFeeStructureQuery,
  useGetCoachingBatchesQuery,
} = batchApiSlice;
